import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getBlogPage } from "@/_pages/blog/api";
import { BlogPage } from "@/_pages/blog/ui";
import type { NewsListType } from "@/_pages/news/model";
import type { NewsPageType } from "@/_pages/news/model/types";

type PageProps = {
  cms: {
    page: NewsPageType;
    list: NewsListType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { list, page },
  } = props;

  return <BlogPage content={list} page={page} />;
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getBlogPage()),
      };
    },
    { res },
  );
}

export default Page;
